import React, { useEffect } from "react";
import { Box, Grid, Backdrop } from "@material-ui/core";
import Heading from "./Heading";
import { InputFields } from "./InputFields";
import { useStyles } from "./styles";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import { loader, selectAllBannedItemsList } from "src/app-redux/configuration/configurationSlice";
import {
  addNewBannedItem,
  getAllBannedItems,
  updateBannedItem,
} from "src/app-redux/configuration/actions/configurationActions";
import { IAddBannedItem } from "src/common/typings/configuration";
import CommonLoader from "src/components/Loader/CommonLoader";

type Props = {
  children?: React.ReactNode;
  index: any;
  value: any;
};

export function BannedItems({ value, index, ...other }: Props): React.ReactElement {
  const dispatch = useAppDispatch();
  const classes = useStyles();
  const pageHeading = "Banned Items";
  const tableRecord: any = useAppSelector(selectAllBannedItemsList);
  const loader2 = useAppSelector(loader);

  useEffect(() => {
    dispatch(getAllBannedItems());
  }, []);

  const updateSubmit = async (formData: IAddBannedItem) => {
    const res: any = await dispatch(updateBannedItem(formData));
    if (res.payload) dispatch(getAllBannedItems());
  };

  const handleSubmit = async (formData: IAddBannedItem) => {
    const res: any = await dispatch(addNewBannedItem(formData));
    if (res.payload) dispatch(getAllBannedItems());
  };

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <>
          <Backdrop className={classes.backdrop} open={loader2}>
            <CommonLoader />
          </Backdrop>
          <Box borderColor="grey.200">
            <Heading heading={pageHeading} />
            <Box borderTop={2} mb={1} borderColor="grey.200"></Box>
            <Grid container direction="row">
              <Grid item xs={12} md={12}>
                {/* Conent Start */}
                <InputFields
                  updateSubmit={updateSubmit}
                  handleSubmit={handleSubmit}
                  tableRecord={tableRecord || []}
                  loading={loader2}
                />
                {/* Conent End */}
              </Grid>
            </Grid>
          </Box>
        </>
      )}
    </div>
  );
}
